import { App } from 'vue';

export default {
  install: (app: App) => {
    // Register App components dynamically.
    const files = require.context('@/components', true, /\.(vue|js)$/i);
    files.keys().map((key) => app.component((key.split('/').pop() as string).split('.')[0], files(key).default));
  },
};
